import {Injectable} from '@angular/core';
import {NestApiProvider} from '../../nest-api';
import {Observable} from 'rxjs';
import {ResponseData, ResponsePaging} from '../../nest-responses';
import {
  RequestListApprovalDto,
  RequestListingDto,
  RequestPagingDto,
  RequestPayloadDto,
  ResponseListingShiftScheduleRequestDto,
} from '../dto/shift-schedule-request.dto';

@Injectable()
export class ShiftScheduleRequestApi {
  private readonly service: string = '';
  private readonly model: string = 'shiftScheduleRequest';

  constructor(
      private readonly nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: RequestListingDto, paging?: RequestPagingDto): Observable<ResponsePaging<ResponseListingShiftScheduleRequestDto>> {
    const method: string = 'POST';
    const func: string = 'listing';
    const params: any = payload || {};
    const urlParams: any = paging || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseListingShiftScheduleRequestDto>>(method, url, params, urlParams, body);
  }

  public add(payload: RequestPayloadDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public deleteDraft(payload: RequestPayloadDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'deleteDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public draft(payload: RequestPayloadDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'draft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public cancel(payload: RequestPayloadDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'cancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public approve(payload: RequestPayloadDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'approve';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public revise(payload: RequestPayloadDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'revise';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public reject(payload: RequestPayloadDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'reject';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public getShiftScheduleReqApproval(payload: RequestListApprovalDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'getShiftScheduleReqApproval';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/shift-schedule-request.api.ts